export default __webpack_public_path__ + "static/6860-5c0a049c62c9159ac16ce9d6a466a203.jpg";